import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {ModalController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {MultipleSelectComponent} from 'src/app/components/multiple-select-component/multiple-select-component';
import {ChooseEmotionComponent} from 'src/app/modules/user/auth/reports/choose-emotion/choose-emotion.component';
import {LoadingService} from '../../../../_services/loading.service';
import {LocalStorageService, UserService} from '../../../../_services';

@Component({
  selector: 'app-map-filter',
  templateUrl: './map-filter.component.html',
  styleUrls: ['./map-filter.component.scss'],
})
export class MapFilterComponent implements OnInit {
  @ViewChild('agePlaceholder') agePlaceholder: ElementRef;
  @ViewChild('genderPlaceholder') genderPlaceholder: ElementRef;
  @Input() filterData: any;
  @Input() emotions = [];
  @Input() ages = [];
  @Input() genders = [];
  @Input() selectedCategoryList = [];
  @Input() selectedOrganisationSize = [];
  @Input() selectedOperationTime = [];
  categoryList = [];
  organisationSizeList = [
    {name: 'Independent practitioner', _id: 'Independent practitioner'},
    {name: 'Micro (0-4)', _id: 'Micro (0-4)'},
    {name: 'Small (5-19)', _id: 'Small (5-19)'},
    {name: 'Medium (20-199)', _id: 'Medium (20-199)'},
    {name: 'Large (200+)', _id: 'Large (200+)'}];
  operationTime = [{name: 'Day', _id: 'Day'}, {name: 'Night', _id: 'Night'}, {name: 'Day & night', _id: 'Day & night'}];
  mapFilterForm: FormGroup;
  emotionsList = '';
  reportsText: any;
  mapText: any;
  agePlaceholderLabel = 'All ages selected';
  genderPlaceholderLabel = 'All genders selected';
  categoryPlaceholderLabel = 'All categories selected';
  organisationSizePlaceholderLabel = 'All selected';
  operationTimePlaceholderLabel = 'All selected';
  selectedProjectObj: any;

  constructor(public translate: TranslateService,
              private spinner: LoadingService,
              private adminService: UserService,
              private localStorage: LocalStorageService,
              private modalController: ModalController) {

    this.selectedProjectObj = this.localStorage.get('selected_project');

    this.getCategories();
    this.mapFilterForm = new FormGroup({
      totalEmotion: new FormControl('', []),
      age: new FormControl('', []),
      gender: new FormControl('', [])
    });
  }

  ngOnInit() {
    if (this.emotions.length > 0) {
      this.mapFilterForm.get('totalEmotion').setValue(this.emotions.length + ' ' + 'emotion selected');
    }
    if (this.ages.length > 0) {
      this.agePlaceholderLabel = this.ages.length + ' age groups selected';
    }
    if (this.genders.length > 0) {
      this.genderPlaceholderLabel = this.genders.length + ' ' + 'genders selected';
    }
    if (this.selectedCategoryList.length > 0) {
      this.categoryPlaceholderLabel = this.selectedCategoryList.length + ' ' + 'categories selected';
    }
    if (this.selectedOrganisationSize.length > 0) {
      this.organisationSizePlaceholderLabel = this.selectedOrganisationSize.length + ' ' + 'selected';
    }
    this.translate.get(['reports', 'map']).subscribe(
      (values) => {
        this.reportsText = values.reports;
        this.mapText = values.map;
      });
  }

  async chooseEmotion() {
    const modal = await this.modalController.create({
      component: ChooseEmotionComponent,
      componentProps: {
        parentEmotions: this.emotions,
        fromFilter: true
      },
      cssClass: 'custom-modal',
      showBackdrop: true,
      backdropDismiss: true,
      swipeToClose: true
    });
    modal.onDidDismiss()
      .then((data) => {
        if (data.data) {
          this.emotions = data.data;
          if (this.emotions.length > 0) {
            this.emotions.forEach((emotions, index) => {
              if (index === 0) {
                this.emotionsList = emotions.id;
              } else {
                this.emotionsList = this.emotionsList + ',' + emotions.id;
              }
            });
            if (this.emotions.length === 1) {
              this.mapFilterForm.get('totalEmotion').setValue(this.emotions.length + ' ' + this.reportsText.emotion_selected);
            } else {
              this.mapFilterForm.get('totalEmotion').setValue(this.emotions.length + ' ' + this.reportsText.emotions_selected);
            }
          }
        }
      });
    return await modal.present();
  }

  async openAgeModal(type: string) {
    {
      const selectedList = this.ages;
      const listingObj = [{title: 'Show all ages', _id: 'all'},
        {title: '12 and under', _id: '12'},
        {title: '13 - 18', _id: '13'},
        {title: '19 - 25', _id: '19'},
        {title: '26 - 35', _id: '26'},
        {title: '36 - 45', _id: '36'},
        {title: '46 - 55', _id: '46'},
        {title: '56 +', _id: '56'}];
      const modal = await this.modalController.create({
        component: MultipleSelectComponent,
        cssClass: 'custom-menu confirm',
        showBackdrop: true,
        backdropDismiss: true,
        swipeToClose: true,
        componentProps: {
          listingObj,
          selectedOptions: selectedList,
          singleSelector: true
        }
      });

      modal.onDidDismiss()
        .then((dataObj: any) => {
          if (dataObj.data.selectedGigs) {
            this.ages = dataObj.data.selectedGigs;
            if (this.ages.length === 1) {
              // this.mapFilterForm.get('age').setValue(this.ages[0].title);
              // eslint-disable-next-line no-underscore-dangle
              this.agePlaceholder.nativeElement.innerHTML = listingObj.filter(obj => obj._id === this.ages[0])[0].title;
            } else {
              // this.mapFilterForm.get('age').setValue(this.ages.length + ' ' + this.mapText.age_groups_selected);
              this.agePlaceholder.nativeElement.innerHTML = this.ages.length + ' ' + this.mapText.age_groups_selected;
            }
          }
        });
      return await modal.present();
    }
  }

  async openGenderModal(type: string) {
    {
      const selectedList = this.genders;
      const listingObj = [{title: 'Male', _id: 'male'},
        {title: 'Female', _id: 'female'},
        {title: 'Other', _id: 'other'},
        {title: 'Not Say', _id: 'not_say'}];
      const modal = await this.modalController.create({
        component: MultipleSelectComponent,
        cssClass: 'custom-menu',
        showBackdrop: true,
        backdropDismiss: true,
        swipeToClose: true,
        componentProps: {
          listingObj,
          selectedOptions: selectedList
        }
      });

      modal.onDidDismiss()
        .then((dataObj: any) => {
          if (dataObj.data.selectedGigs) {
            this.genders = dataObj.data.selectedGigs;
            if (this.genders.length === 1) {
              // this.mapFilterForm.get('age').setValue(this.genders[0].title);
              // eslint-disable-next-line no-underscore-dangle
              this.genderPlaceholder.nativeElement.innerHTML = listingObj.filter(obj => obj._id === this.genders[0])[0].title;
            } else {
              // this.mapFilterForm.get('age').setValue(this.genders.length + ' ' + this.mapText.genders_selected);
              this.genderPlaceholder.nativeElement.innerHTML = this.genders.length + ' genders selected';
            }
          }
        });
      return await modal.present();
    }
  }


  async genericModal(type: string) {
    {
      let selectedList = [];
      let listingObj = [];
      if (type === 'Category') {
        selectedList = this.selectedCategoryList;
        listingObj = this.categoryList;
      } else if (type === 'organisationSize') {
        selectedList = this.selectedOrganisationSize;
        listingObj = this.organisationSizeList;
      } else {
        selectedList = this.selectedOperationTime;
        listingObj = this.operationTime;
      }
      const modal = await this.modalController.create({
        component: MultipleSelectComponent,
        cssClass: 'custom-modal',
        showBackdrop: true,
        backdropDismiss: true,
        componentProps: {
          listingObj,
          selectedOptions: selectedList
        }
      });

      modal.onDidDismiss()
        .then((dataObj: any) => {
          if (dataObj.data.selectedGigs) {
            if (type === 'Category') {
              this.selectedCategoryList = dataObj.data.selectedGigs;
              if (this.selectedCategoryList.length === 1) {
                this.categoryPlaceholderLabel = 'One category selected';
              } else {
                this.categoryPlaceholderLabel = this.selectedCategoryList.length + ' categories selected';
              }
            } else if (type === 'organisationSize') {
              this.selectedOrganisationSize = dataObj.data.selectedGigs;
              if (this.selectedOrganisationSize.length === 1) {
                this.organisationSizePlaceholderLabel = 'One option selected';
              } else {
                this.organisationSizePlaceholderLabel = this.selectedCategoryList.length + ' options selected';
              }
            } else {
              this.selectedOperationTime = dataObj.data.selectedGigs;
              if (this.selectedOperationTime.length === 1) {
                this.operationTimePlaceholderLabel = 'One option selected';
              } else {
                this.operationTimePlaceholderLabel = this.selectedOperationTime.length + ' options selected';
              }
            }
          }
        });
      return await modal.present();
    }
  }

  back() {
    this.modalController.dismiss();
  }

  applyFilters() {
    this.modalController.dismiss({
      emotions: this.emotions,
      ages: this.ages,
      genders: this.genders,
      categoryList: this.selectedCategoryList,
      organisationSize: this.selectedOrganisationSize,
      operationTime: this.selectedOperationTime
    });
  }

  clearFilters() {
    sessionStorage.removeItem('filter_data');
    sessionStorage.removeItem('filter_emotion');
    sessionStorage.removeItem('filter_gender');
    sessionStorage.removeItem('filter_category');
    sessionStorage.removeItem('filter_organisationSize');
    sessionStorage.removeItem('filter_operationTime');
    this.modalController.dismiss({});
  }

  onSubmit() {

  }

  dismiss() {
    this.modalController.dismiss();
  }


  getCategories() {
    this.spinner.show();
    // eslint-disable-next-line no-underscore-dangle
    this.adminService.getSiteCategory(this.selectedProjectObj._id)
      .subscribe({
        next: (value) => {
          this.spinner.hide();
          this.categoryList = value;
          this.categoryList.map(obj => Object.assign(obj, {_id: obj.name}));
        },
        error: err => {
          this.spinner.hide();
        }
      });
  }
}
